import axios from 'axios';

// Vite environments: .env.local usually overrides, DEV is true locally
// We use the new API base locally (http://localhost:8080) and production URL online
// If we deploy phase 1/2 API to server, it will be same URL.
export const API_BASE_URL = import.meta.env.VITE_API_URL ||
    (import.meta.env.DEV ? 'http://localhost:8080/api' : '/api');

export const api = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true, // Cookies (Admin/Município)
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Injetar token de membro se existir (PWA)
api.interceptors.request.use((config) => {
    const memberToken = localStorage.getItem('aconturs_member_token');
    if (memberToken) {
        config.headers.Authorization = `Bearer ${memberToken}`;
    }
    return config;
});

// Response interceptor for session expiry handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const { status } = error.response || {};
        const { pathname } = window.location;

        if (status === 401) {
            // ADMIN
            if (pathname.startsWith('/admin') && !pathname.includes('/login')) {
                window.location.href = '/admin/login';
            }
            // PWA
            if (pathname.startsWith('/app') && !pathname.includes('/login')) {
                localStorage.removeItem('aconturs_member_token');
                window.location.href = '/app/login';
            }
        }
        return Promise.reject(error);
    }
);
